import type { ReactNode } from "react";

type CollectionPreviewProps = {
  id: string;
  title: string;
  description: string;
  children: ReactNode;
};

export function CollectionPreview({
  id,
  title,
  description,
  children,
}: CollectionPreviewProps) {
  return (
    <section
      className="section collection-preview"
      aria-labelledby={`${id}-title`}
    >
      <div className="section-heading reveal-item">
        <h2 id={`${id}-title`}>{title}</h2>
        <p>{description}</p>
      </div>
      {children}
    </section>
  );
}
